module.exports = __webpack_public_path__ + "img/PXioNf1l-EmRPaQ,UDT.7cca1b56.jpeg";